import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import CTALinks from 'components/CTALinks';
import Fade from 'components/Fade';
import { Grid, Cell } from 'components/Grid';
import { Small, MediumUp } from 'components/MediaQuery';
import RichText from 'components/RichText';
import { BACKGROUND_TYPES } from 'constants/homepage';
import { medium, largeUp } from 'constants/mediaQueries';
import SecondaryPromoHero from 'models/SecondaryPromoHero';
import Theme from 'styles/theme';

import BackgroundImage from './BackgroundImage';
import BackgroundVideo from './BackgroundVideo';
import { EVENTS } from './constants';
import InlineVideoPlayer from './InlineVideoPlayer';
import PlayButton from './PlayButton';

class ArticlePagePromoHero extends React.Component {
  constructor() {
    super();
    this.state = { inlineVideoOpen: false };
  }

  get videoPlaying() {
    return !!(this.props.videoModalOpen || this.state.inlineVideoOpen);
  }

  openVideoModal = () => {
    const { openVideoModal, data } = this.props;
    openVideoModal(data.videoUrl);
    this.trackVideoOpen();
  };

  openInlineVideo = () => {
    this.setState({ inlineVideoOpen: true });
    this.trackVideoOpen();
  };

  closeInlineVideo = () => {
    this.setState({ inlineVideoOpen: false });
  };

  trackCTAClick = url =>
    this.props.trackEvent({ eventAction: EVENTS.CLICK_SHOP_CTA, eventLabel: url });

  trackVideoOpen = () =>
    this.props.trackEvent({
      eventAction: EVENTS.WATCH_VIDEO,
      eventLabel: this.props.data.videoUrl,
    });

  render() {
    const { data } = this.props;
    const { inlineVideoOpen } = this.state;

    return (
      <div className="ArticlePagePromoHero">
        <div className="ArticlePagePromoHero__wrapper">
          {data.backgroundType === BACKGROUND_TYPES.VIDEO && (
            <BackgroundVideo video={data.backgroundAsset} paused={this.videoPlaying} />
          )}
          {data.backgroundType === BACKGROUND_TYPES.IMAGE && (
            <BackgroundImage image={data.backgroundAsset} />
          )}
          {data.videoUrl && (
            <>
              <Small>
                <PlayButton onClick={this.openVideoModal} />
              </Small>
              <MediumUp>
                <PlayButton onClick={this.openInlineVideo} />
              </MediumUp>
            </>
          )}
          <Fade show={inlineVideoOpen}>
            <InlineVideoPlayer onClose={this.closeInlineVideo} videoUrl={data.videoUrl} />
          </Fade>
        </div>
        <Grid isCentered>
          <Cell small={{ columns: 12 }} medium={{ columns: 12 }} largeUp={{ columns: 8 }}>
            <div className="ArticlePagePromoHero__copy">
              {data.copy && <RichText content={data.copy} />}
              {get(data.ctaLinks, 'length') > 0 && (
                <CTALinks
                  className="ArticlePagePromoHero__cta-links"
                  links={data.ctaLinks}
                  onClick={this.trackCTAClick}
                />
              )}
            </div>
          </Cell>
        </Grid>
        <style jsx>
          {`
            .ArticlePagePromoHero {
              position: relative;
              width: 100%;
              height: 100%;
            }

            .ArticlePagePromoHero__wrapper {
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              background-color: ${Theme.get('colors-grey')};
            }

            .ArticlePagePromoHero__copy {
              margin-top: ${Theme.get('spacing') * 7}px;
            }

            @media ${medium} {
              .ArticlePagePromoHero__copy {
                margin-top: ${Theme.get('spacing') * 10}px;
              }
            }

            @media ${largeUp} {
              .ArticlePagePromoHero__copy {
                margin-top: ${Theme.get('spacing') * 14}px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

ArticlePagePromoHero.propTypes = {
  data: PropTypes.instanceOf(SecondaryPromoHero).isRequired,
  videoModalOpen: PropTypes.bool,
  openVideoModal: PropTypes.func,
  trackEvent: PropTypes.func,
};

ArticlePagePromoHero.defaultProps = {
  videoModalOpen: false,
  openVideoModal: () => {},
  trackEvent: () => {},
};

export default ArticlePagePromoHero;
